export const JOB_OPTIONS = [
    { labelKey: 'career.form.jobs.pilotTester', value: 'pilot-tester' },
    { labelKey: 'career.form.jobs.pilotInstructor', value: 'pilot-instructor' },
    { labelKey: 'career.form.jobs.arduplaneEngineer', value: 'arduplane-engineer' },
    { labelKey: 'career.form.jobs.embeddedArdu', value: 'embedded-ardu' },
    { labelKey: 'career.form.jobs.uavRepair', value: 'uav-repair' },
    { labelKey: 'career.form.jobs.financeManager', value: 'finance-manager' },
    { labelKey: 'career.form.jobs.assembler', value: 'assembler' },
    { labelKey: 'career.form.jobs.soldering', value: 'soldering' },
];
